import React from "react";
import {Flex, Text} from "@chakra-ui/core";

const FailedScreen = () => (
  <Flex alignItems="center" height="100%" justifyContent="center">
    <Text color="gray.500" fontSize="lg">
      Hubo un error obteniendo los productos, intente de nuevo mas tarde
    </Text>
  </Flex>
);

export default FailedScreen;
